import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
import useRouter from '@/composables/useRouter'
import useLegalSearch from './composables/useLegalSearch'
import { useAuthStore } from '@/stores/auth/useAuthStore'
import { useI18n } from 'vue-i18n-composable'
import { Icons } from '@/icons/icons'
import { formatNumber } from '@/helpers/numeric'
import LfLabelButtonComponent from '@/components/forms/buttons/label/LfLabelButtonComponent.vue'
import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import PaginationComponent from '@/components/Pagination/PaginationComponent.vue'
import SpinnerLayerComponent from '@/components/Spinner/SpinnerLayerComponent.vue'
import { vars } from '@/styles/styleVars'
import { TabType } from './types/index'
import { LegalSearchDataType } from '@/store/modules/legalSearch/legalSearchTypes'


export default /*#__PURE__*/_defineComponent({
  __name: 'LegalSearchComponent',
  setup(__props) {

const { route } = useRouter()
const authStore = useAuthStore()
const { sessionId, searchTabs, searchData, loadSessionId, loadSearchTabs, loadSearchData } = useLegalSearch()

// TRANSLATIONS
const { t } = useI18n()
const texts = {
  legalBtn: t('components.legal_search.legal_btn').toString(),
  legalTooltip: t('components.legal_search.legal_tooltip').toString(),
  of: t('components.pagination.of').toString(),
  pages: t('components.pagination.pages').toString(),
  recsPerPage: t('components.pagination.records_per_page').toString(),
  registers: t('components.pagination.registers').toString()
}

// DATA
const icons = {
  database: Icons.DATABASE,
  doubleArrowLeft: Icons.DOUBLE_ARROW_LEFT,
  doubleArrowRight: Icons.DOUBLE_ARROW_RIGHT,
  arrowDown: Icons.ANGLE_DOWN
}
const numRecsPerPage = [5, 10, 20, 50]
const numPage = ref<number>(0)
const recsPerPage = ref(5)
const totalPages = ref(0)
const maxVisibleButtonsPage = ref(5)
const selectedTabIndex = ref(0)
const selectedCurrentTabIndex = ref(0)
const showContent = ref(true)
const currentTab = ref<TabType | null>(null)
const tabs = ref<TabType[]>(Array.isArray(searchTabs.value) ? searchTabs.value : [])
const data = Array.isArray(searchData.value) ? (searchData.value as LegalSearchDataType[]) : []
const searchTerm = computed(() => route?.params?.searchTerm ?? '')
const showPaginator = computed(() => currentTab.value && currentTab.value.occurrences > recsPerPage.value)
const numPagesLiteral = computed(() => {
  if (showPaginator.value && currentTab.value) {
    return `${numPage.value + 1} ${texts.of} ${totalPages.value} ${texts.pages} (${formatNumber(
      currentTab.value.occurrences
    )} ${texts.registers})`
  }
  return ''
})

// GETTERS
const encryptedUserId = computed<string>(() => authStore.encryptedUserId)

// METHODS
async function onTabChange(tab: TabType) {
  if (!currentTab.value || tab.area !== currentTab.value.area) {
    numPage.value = 0
  }
  currentTab.value = tab
  authStore.cancelPendingRequests()
  showContent.value = false
  await loadSearchData(searchTerm.value, sessionId.value, tab.area, numPage.value, recsPerPage.value)
  showContent.value = true
  totalPages.value = Math.ceil(currentTab.value.occurrences / recsPerPage.value)
}

function onPageChanged(page: number) {
  numPage.value = page - 1
  if (currentTab.value) {
    onTabChange(currentTab.value)
  }
}

function refreshSearch() {
  numPage.value = 0
  if (currentTab.value) {
    onTabChange(currentTab.value)
  }
}

function viewDocumentOnApp(nRef: string) {
  window.open(
    `${process.env.VUE_APP_LEGAL_SEARCH_OPEN_SERVICE}?ei=${encryptedUserId.value}&producto_inicial=UNIVERSAL&nref=${nRef}`,
    '_blank'
  )
}

function openSearchOnApp() {
  if (currentTab.value) {
    window.open(
      `${process.env.VUE_APP_LEGAL_SEARCH_OPEN_SERVICE}?ei=${encryptedUserId.value}&producto=UNIVERSAL&orden=relevancia&universal=${searchTerm.value}&subindices=${currentTab.value.area}`,
      '_blank'
    )
  }
}

const cssVars = computed(() => ({
  '--pagination-container-margin': 0,
  '--pagination-btn-active': vars.corporate_color,
  '--pagination-btn-active-border': vars.corporate_color,
  '--pagination-icon-color': vars.corporate_color,
  '--pagination-btn-not-active-border': vars.white_01,
  '--pagination-btn-color': vars.gray_01,
  '--pagination-btn-hover-color': vars.gray_01,
  '--pagination-icon-inactive-color': vars.disabled_color
}))

// HOOKS
onMounted(async () => {
  if (!tabs.value || tabs.value.length === 0) {
    await loadSessionId(encryptedUserId.value)
    await loadSearchTabs(searchTerm.value, sessionId.value)
  }
  if (tabs.value && tabs.value.length > 0) {
    await onTabChange(tabs.value[selectedTabIndex.value])
  }
})

return { __sfc: true,route, authStore, sessionId, searchTabs, searchData, loadSessionId, loadSearchTabs, loadSearchData, t, texts, icons, numRecsPerPage, numPage, recsPerPage, totalPages, maxVisibleButtonsPage, selectedTabIndex, selectedCurrentTabIndex, showContent, currentTab, tabs, data, searchTerm, showPaginator, numPagesLiteral, encryptedUserId, onTabChange, onPageChanged, refreshSearch, viewDocumentOnApp, openSearchOnApp, cssVars, LfLabelButtonComponent, LabelButtonVariant, PaginationComponent, SpinnerLayerComponent }
}

})